module.exports = __webpack_public_path__ + "static/media/ao.2359a082.svg";